const propRe = /^((data|aria)-.*)$/;
function filterDOMProps(props, opts) {
  const filteredProps = {};
  Object.keys(props).filter((prop) => {
    var _a;
    return ((_a = opts == null ? void 0 : opts.propNames) == null ? void 0 : _a.has(prop)) || propRe.test(prop);
  }).forEach((prop) => {
    filteredProps[prop] = props[prop];
  });
  return filteredProps;
}
export {
  filterDOMProps
};
//# sourceMappingURL=filterDOMProps.es.js.map
